"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _card = _interopRequireDefault(require("@berlitz/card"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _layout = require("@berlitz/globals/lib/components/layout");
var _button = _interopRequireDefault(require("@berlitz/button"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _resizeImage = _interopRequireDefault(require("@berlitz/max-utils/lib/resizeImage"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _style = require("./style");
var _isExternalLink = _interopRequireDefault(require("@berlitz/max-utils/lib/isExternalLink"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ConditionalWrap = function ConditionalWrap(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  // Add Link wrapper if card contains a link
  return condition ? wrapper(children) : children;
};
var CardInner = function CardInner(_ref2) {
  var text = _ref2.text,
    textAlign = _ref2.textAlign,
    subtitle = _ref2.subtitle,
    highlight = _ref2.highlight,
    isTitleH3 = _ref2.isTitleH3;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, text && /*#__PURE__*/_react.default.createElement(_typography.P, {
    fontWeight: "bold",
    highlight: highlight,
    size: "lg",
    "data-key": "cards__card-text",
    textAlign: textAlign,
    isTitleH3: isTitleH3
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: textAlign
  }, text)), subtitle && /*#__PURE__*/_react.default.createElement(_typography.RichText, {
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }));
};
var BlockCards = function BlockCards(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
    cards = _ref3.cards,
    _ref3$cardsAsRows = _ref3.cardsAsRows,
    cardsAsRows = _ref3$cardsAsRows === void 0 ? false : _ref3$cardsAsRows,
    _ref3$containerWidth = _ref3.containerWidth,
    containerWidth = _ref3$containerWidth === void 0 ? 'lg' : _ref3$containerWidth,
    disablePaddingBottom = _ref3.disablePaddingBottom,
    disablePaddingTop = _ref3.disablePaddingTop,
    flat = _ref3.flat,
    largeCards = _ref3.largeCards,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'lg' : _ref3$size,
    subtitle = _ref3.subtitle,
    title = _ref3.title,
    ctaAsLink = _ref3.ctaAsLink;
  var hasOrphan = cards.length % 3 === 1 && cards.length !== 1;
  var lgColumns = (0, _react.useMemo)(function () {
    if (largeCards || cardsAsRows) return 6;
    return hasOrphan ? 3 : 4;
  }, []);
  var containerWidths = {
    md: 9,
    lg: 12
  };
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: backgroundColor,
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_style.StyledGrid, null, (title || subtitle) && /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 9
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: "center"
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    "data-key": "cards__heading"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_style.SubText, {
    "data-key": "cards__subtext"
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "xl",
    breakpoints: {
      lg: 'md'
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: containerWidths[containerWidth]
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, cards.map(function (card, index) {
    return /*#__PURE__*/_react.default.createElement(_style.StyledCol, {
      xs: 12,
      sm: 6,
      lg: lgColumns,
      key: "feature-card-".concat(card.imageSrc, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(ConditionalWrap, {
      condition: card.url,
      wrapper: function wrapper(children) {
        return /*#__PURE__*/_react.default.createElement(_style.CardLink, {
          href: card.url,
          target: (0, _isExternalLink.default)(card.url) ? '_blank' : '_self',
          "data-key": "cards__card-link"
        }, children);
      }
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      flat: flat,
      image: card.imageSrc && (0, _resizeImage.default)(card.imageSrc, 640, 480),
      imageAltText: card.imageSrc && (card.imageAlt || ''),
      cta: card.url && card.ctaText && (!ctaAsLink ? /*#__PURE__*/_react.default.createElement(_button.default, {
        "data-key": "cards__card-cta__button",
        as: "span"
      }, card.ctaText) : /*#__PURE__*/_react.default.createElement(_style.Link, {
        href: card.url,
        to: card.url
      }, card.ctaText)),
      borderColor: card.borderColor,
      row: cardsAsRows,
      youtubeVideoId: card.youtubeVideoId,
      containImage: card.containImage,
      hideContent: card.hideContent,
      idAttr: card.idAttr
    }, /*#__PURE__*/_react.default.createElement(CardInner, {
      text: card.text,
      textAlign: card.textAlign,
      subtitle: card.subtitle,
      highlight: card.highlight,
      isTitleH3: card.isTitleH3
    }))));
  }))))));
};
var _default = BlockCards;
exports.default = _default;